import { Controller } from "@hotwired/stimulus"
import { Autocomplete } from 'stimulus-autocomplete'

export default class extends Autocomplete {
  static values = {
    fieldsForParam: { type: String, default: '' }
  }

  buildURL (query) {
    const url = new URL(this.urlValue, window.location.href)
    const params = new URLSearchParams(url.search)

    this.fieldsForParamValue.split(" ").forEach(element => {
      params.append(element, document.getElementById(element).value)
    });

    params.append(this.queryParamValue, query)
    url.search = params.toString()

    return url.toString()
  }
}
